import gql from 'graphql-tag'

export default gql`
  query MultiSelectProductVariant {
    productVariants(perPage: 100) {
      nodes {
        id
        title
      }
    }
  }
`
